module.exports = __webpack_public_path__ + "static/media/LOGO-QQLM23-2.d39f0823.png";